module.exports = __webpack_public_path__ + "static/spec-1fa7cf5c16554df0dc745a5905be0c30.png";